export default __webpack_public_path__ + "static/patryk_zdunowski-ac79c74cb627c39984583afa900729b6.png";